import React from 'react'

import BaseModal from '../base-modal'
import {
  ModalForm,
  ModalFormRow,
  ModalFormBlock
} from '../modal-form/modal-form'

const constraints = {
  'width': '706px',
  'minWidth': '706px',
  'margin-top': '10%'
}

export default ({
  onClose,
  servicing,
  loading,
  onViewOpenIssues,
  onApproveServicing
}) => {
  if (loading) {
    return <div>Loading...</div>
  }

  const { sameDayIssueCount } = servicing
  const multipleIssues = sameDayIssueCount > 1

  return (
    <BaseModal
      onClose={onClose}
      title="Confirm Approval"
      constraints={constraints}
    >
      <ModalFormRow>
        <p>
          There {multipleIssues ? 'are' : 'is'} {sameDayIssueCount} new open {multipleIssues > 1 ? 'issues' : 'issue'} for the area.
          Would you like to view the open issues, or approve the area anyway?
        </p>
      </ModalFormRow>
      <ModalFormRow>
        <ModalFormBlock submitButton>
          <button onClick={onViewOpenIssues} key='viewOpenIssues'>View Open Issues</button>
          <button onClick={onApproveServicing} key='approve'>Acknowledge and Approve</button>
        </ModalFormBlock>
      </ModalFormRow>
    </BaseModal>
  )
}



// WEBPACK FOOTER //
// ./src/components/servicings/confirm-servicing-approval.js